/* global axios */
import ApiClient from './ApiClient';

class TicketCategoriesAPI extends ApiClient {
  constructor() {
    super('ticket_categories', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(categoryId) {
    return axios.get(`${this.url}/${categoryId}`);
  }

  create(data) {
    return axios.post(this.url, { ticket_category: data });
  }

  update(categoryId, data) {
    return axios.patch(`${this.url}/${categoryId}`, { ticket_category: data });
  }

  delete(categoryId) {
    return axios.delete(`${this.url}/${categoryId}`);
  }

  import(data) {
    return axios.post(`${this.url}/import`, { data: JSON.stringify(data) });
  }

  reorder(positions) {
    return axios.post(`${this.url}/reorder`, { positions });
  }

  // Subcategories
  getSubcategories(categoryId, params = {}) {
    return axios.get(`${this.url}/${categoryId}/ticket_subcategories`, {
      params,
    });
  }

  createSubcategory(categoryId, data) {
    return axios.post(`${this.url}/${categoryId}/ticket_subcategories`, {
      ticket_subcategory: data,
    });
  }

  updateSubcategory(categoryId, subcategoryId, data) {
    return axios.patch(
      `${this.url}/${categoryId}/ticket_subcategories/${subcategoryId}`,
      { ticket_subcategory: data }
    );
  }

  deleteSubcategory(categoryId, subcategoryId) {
    return axios.delete(
      `${this.url}/${categoryId}/ticket_subcategories/${subcategoryId}`
    );
  }

  reorderSubcategories(categoryId, positions) {
    return axios.post(
      `${this.url}/${categoryId}/ticket_subcategories/reorder`,
      { positions }
    );
  }

  getSubcategoryDefaults(categoryId, subcategoryId) {
    return axios.get(
      `${this.url}/${categoryId}/ticket_subcategories/${subcategoryId}/defaults`
    );
  }
}

export default new TicketCategoriesAPI();
